<template>
		<el-dialog title="修改时间及内容" :visible.sync="visible" :before-close="beforeClose" width="70%">
				<el-form :model="form" inline style="margin-top: 30px;">
					<el-row>
						<el-form-item label="工单主题">
								<div>{{form.title}}</div>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="创建时间">
								<el-input v-model="form.rowTime" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
                    <el-row>
						<el-form-item label="回复时间">
								<el-input v-model="form.replyTime" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
                    <el-row>
						<el-form-item label="截单时间">
								<el-input v-model="form.finishDate" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
					<el-divider></el-divider>
					<el-row>
						<el-form-item label="公司名称">
								<el-input v-model="form.companyName" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
						<el-form-item label="联系人">
								<el-input v-model="form.contactUser" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="联系电话">
								<el-input v-model="form.tel" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
						<el-form-item label="邮箱">
								<el-input v-model="form.email" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
					<el-row>
						<el-form-item label="地址">
								<el-input v-model="form.address" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
						<el-form-item label="网域名称">
								<el-input v-model="form.account" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
					<el-divider></el-divider>
					<el-row>
						<el-form-item label="工单号">
								<el-input v-model="form.sheetCode" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
						 <el-form-item label="选择处理人">
                            <el-cascader
                                :options="groupUserList"
                                :props="props"
								filterable
                                v-model="form.toUIds"
                                clearable></el-cascader>
						</el-form-item>

						<!--   -->
					</el-row>
					<el-row>
						<el-form-item label="工单主题">
								<el-input v-model="form.title" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>
					</el-row>
					<el-row>
						<!-- <el-form-item label="工单内容">
								<el-input v-model="form.content" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>  -->

						<el-form-item label="工单内容" style="width: 100%;">
							<el-col :span="24">
								<WangEditorControl
									v-model="form.content"
									placeholder="请输入工单内容"
									:height="300"
									style="width:1000px"
								/>
							</el-col>
						</el-form-item>

					</el-row>
					<el-row>
						<!-- <el-form-item label="回复内容">
								<el-input v-model="form.itemContent" type="text" autocomplete="off"
													class="text-width"></el-input>
						</el-form-item>  -->
						<el-form-item label="回复内容" style="width: 100%;">
							<el-col :span="24">
								<WangEditorControl
									v-model="form.itemContent"
									placeholder="请输入回复内容"
									:height="300"
									style="width:1000px"
								/>
							</el-col>
						</el-form-item>
					</el-row>

				</el-form>

				<div slot="footer" class="dialog-footer">
						<el-button @click="beforeClose">取消</el-button>
						<el-button type="primary" @click="onConfirm">保存</el-button>
				</div>
		</el-dialog>

</template>

<script>
import {UpdateSheetTime} from "@/api/workSheet";
import {getToken} from "@/utils/auth";
import {mapGetters} from "vuex";
import WangEditorControl from '@/components/WangEditorControl';

export default {
		name: "EditAccountDialog",
		components: {WangEditorControl},
		computed: {...mapGetters(['groupUserList'])},
		props: ['visible', 'currentItem'],
		watch: {
				visible(newValue) {
						if (newValue) {
								this.$store.dispatch('workSheet/groupUserList',{userId:null}).catch(() => {});
									this.form = {
										id: this.currentItem.id || 0,
										rowTime: this.currentItem.rowTime || '',
										replyTime: this.currentItem.replyTime || '',
										finishDate: this.currentItem.finishDate || '',
										companyName: this.currentItem.companyName || '',
										contactUser: this.currentItem.contactUser || '',
										tel: this.currentItem.tel || '',
										email: this.currentItem.email || '',
										address: this.currentItem.address || '',
										account: this.currentItem.account || '',
										sheetCode: this.currentItem.sheetCode || '',
										toUIds: this.currentItem.toUIds ? this.currentItem.toUIds * 1 : 0,
										title: this.currentItem.title || '',
										content: this.currentItem.content || '',
										itemContent: this.currentItem.itemContent || '',
									};
						} else {
								// 关闭时重置form，防止下一次打开前残留旧数据
								this.form = {id:0, rowTime:'',replyTime:'',finishDate:'',companyName:'',contactUser:'',tel:'',email:'',address:'',account:'',sheetCode:'',toUIds:0,title:'',content:'',itemContent:''};
						}
				}
		},
		data() {
				return {
						props: { multiple: false },
						form:{id:0, rowTime:'',replyTime:'',finishDate:'',companyName:'',contactUser:'',tel:'',email:'',address:'',account:'',sheetCode:'',toUIds:0,title:'',content:'',itemContent:''},
				};
		},
		methods: {
				async onConfirm() {
						const {id, rowTime,replyTime,finishDate,companyName,contactUser,tel,email,address,account,sheetCode,toUIds,title,content,itemContent} = this.form;
					console.log('aa',toUIds);
					if (!toUIds ) {
						this.$message.warning('请选择处理人')
						return;
					}
					var toid;
					if (Array.isArray(toUIds)){
						toid=toUIds[0];
					}else{
						toid=toUIds;
					}
					console.log('toid',toid);
                        await UpdateSheetTime({userId: getToken(), wsId:id, createDate:rowTime,replyDate:replyTime,finishDate,companyName,contactUser,tel,email,address,account,sheetCode,toUIds:toid,title,content,itemContent});
						this.$emit('saved');
							this.beforeClose();
				},
				beforeClose() {
						this.$emit('update:visible', false);
				}
		}
}
</script>

<style scoped>

</style>

